import { SelectOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'

import { ROUTE_KEYS } from '@constants'

interface RedirectToTicketProps {
  ticketId: number
}

const RedirectToTicket: React.FC<RedirectToTicketProps> = ({ ticketId }) => {
  const handleClick = () => {
    const url = `${ROUTE_KEYS.TICKET}/${ticketId}`
    window.open(url, '_blank')
  }

  return (
    <Tooltip title={`Ir a la vista de ticket #${ticketId}`} placement="left">
      <div style={{ marginLeft: '20px' }}>
        <SelectOutlined onClick={handleClick} />
      </div>
    </Tooltip>
  )
}

export default RedirectToTicket
